"use client"

import React, { createContext, useContext } from "react"
import { useContactInfo } from "@/hooks/useContactInfo"
import type { ContactInfoResDTO } from "@/types/api"

interface ContactInfoContextType {
  contactInfo: ContactInfoResDTO
  loading: boolean
  error: string | null
  refetch: () => void
  setContactInfo: (info: ContactInfoResDTO) => void
}

export const ContactInfoContext = createContext<ContactInfoContextType | undefined>(undefined)

export function ContactInfoProvider({ children }: { children: React.ReactNode }) {
  const contactInfoState = useContactInfo({ autoFetch: true })

  return (
    <ContactInfoContext.Provider value={contactInfoState}>
      {children}
    </ContactInfoContext.Provider>
  )
}

export function useContactInfoContext() {
  const context = useContext(ContactInfoContext)
  if (context === undefined) {
    throw new Error("useContactInfoContext must be used within a ContactInfoProvider")
  }
  return context
}